import styled from "@emotion/styled";
import { LdButton, LdHeader } from "@liquid/react";
import { NavLink } from "react-router-dom";

import { HEADER_HEIGHT, zIndex } from "@src/styles";
import { pxToRem } from "@src/utils";

const StyledHeader = styled(LdHeader)`
  --ld-header-max-width: 100%;
  --ld-header-height: ${pxToRem(HEADER_HEIGHT)};
  background-color: #503291;
  position: sticky;
  top: 0;
  z-index: ${zIndex.header};

  &::part(container) {
    padding: 0 ${pxToRem(32)};
  }

  &::part(site-name) {
    margin-right: ${pxToRem(40)};
    color: var(--ld-col-vy-200);
  }

  &::part(logo-wrapper) {
    display: none;
  }
`;

const StyledNavLink = styled(NavLink)`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${pxToRem(7.5)} ${pxToRem(16)};
  text-decoration: none;
  border-radius: 4px;
  color: var(--ld-col-wht);
  margin-right: 4px;

  :hover {
    background-color: var(--ld-col-wht-alpha-low);
  }

  :active,
  :focus-visible {
    background-color: var(--ld-col-wht-alpha-lowest);
    color: var(--ld-col-wht-alpha-highest);
  }

  &.active {
    background-color: var(--ld-thm-primary);
  }
`;

const StyledAvatarButton = styled(LdButton)`
  margin: 0;
  &[aria-expanded="true"] svg {
    transform: rotate(180deg);
  }

  &::part(button focusable) {
    gap: ${pxToRem(20)};
  }
`;

export { StyledNavLink, StyledHeader, StyledAvatarButton };
